var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWholesaleSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6896 8.73438H18.4711V9.91773C18.4711 10.1779 18.2602 10.3888 18 10.3888C17.7399 10.3888 17.529 10.1779 17.529 9.91773V8.73438H14.3105C13.7178 8.73438 13.2356 9.21656 13.2356 9.80926V16.3629H18.0001H22.7646V9.80926C22.7645 9.21656 22.2823 8.73438 21.6896 8.73438Z",
    fill: "#00683A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.3796V24.1881C8 24.7808 8.48219 25.263 9.07488 25.263H17.5289V17.3047H9.07488C8.48219 17.3047 8 17.787 8 18.3796Z",
    fill: "#FFC20E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9251 17.3047H18.4711V25.263H26.9251C27.5178 25.263 28 24.7808 28 24.1881V18.3796C28 17.787 27.5178 17.3047 26.9251 17.3047Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleSales);
export default __webpack_public_path__ + "static/media/wholesale-sales.1331b5af.svg";
export { ForwardRef as ReactComponent };